import { FocusEvent } from 'react';
import { useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { round } from '@texas/utils/helpers/numberHelpers';

/**
 * Returns a factory that builds an onBlur handler which rounds a numeric
 * input to `decimals` places and calls `setter` with the rounded number.
 * Shows a toast if rounding changes the value.
 */
export function useBlurRound() {
  const toast = useToast();
  const { t } = useTranslation();

  return (decimals: number, setter: (value: number) => void) =>
    (e: FocusEvent<HTMLInputElement>) => {
      const parsed = parseFloat(e.target.value);
      if (isNaN(parsed)) return;
      const rounded = round(parsed, decimals);
      if (rounded !== parsed) {
        toast({
          title: t('general.valueRounded'),
          status: 'info',
          duration: 3000,
          isClosable: true,
        });
      }
      setter(rounded);
    };
}
